module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-container"
  }, [_c('div', {
    staticClass: "main-box"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("欢迎使用音像电子出版单位年度核验管理系统")]), _vm._v(" "), (_vm.userInfo.orgType == 2) ? _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "出版单位类型",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sumNum",
      "label": "出版单位数量",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 99)
            }
          }
        }, [_vm._v(_vm._s(scope.row.sumNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uncommitNum",
      "label": "未提交数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 8)
            }
          }
        }, [_vm._v(_vm._s(scope.row.uncommitNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "waitCheckNum",
      "label": "待审核数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 0)
            }
          }
        }, [_vm._v(_vm._s(scope.row.waitCheckNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkNum",
      "label": "已审核数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-icon', {
          attrs: {
            "name": "sumNum"
          }
        }), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          },
          on: {
            "click": function($event) {
              _vm.handTopage(scope.row.type, 1)
            }
          }
        }, [_vm._v(_vm._s(scope.row.checkNum))])]
      }
    }])
  })], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab9f165c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/index.vue
// module id = 1791
// module chunks = 1